import { createUrlResolver, siteNames } from '@seek/melways-sites';
import { createContext, useContext } from 'react';

import { Environment } from 'src/types/types';

import type { ConfigOptions, ConfigUtils } from './types';

export const defaultConfig: ConfigOptions = {
  site: siteNames.employer.seek.au,
  locale: 'en-AU',
  environment: Environment.development,
  appVersion: 'unknown',
  basePathName: '/',
  branch: 'unknown',
};

const urlResolver = createUrlResolver({
  site: siteNames.employer.seek.au,
  language: 'en-AU',
  staging: false,
});

export const defaultConfigUtils: ConfigUtils = {
  isProd: false,
  isStaging: false,
  urlResolver,
};

export const ConfigContext = createContext<ConfigOptions & ConfigUtils>({
  ...defaultConfig,
  ...defaultConfigUtils,
});

export const useConfig = () => useContext(ConfigContext);
